import React from 'react';
import HomeListManager from '../admincomponents/HomeListManager';

function AdminHomeHighlights() {
  return (
    <HomeListManager
      title="Key Highlights"
      urlPath="home-highlights"
      imageField="icon"
      emptyMessage='No highlights yet — click "Add" to create the first one (the 3-point feature cards on the homepage).'
      fields={[
        { name: 'title', label: 'Title', required: true, placeholder: 'e.g. Global Job Opportunities' },
        { name: 'description', label: 'Description', type: 'textarea', colClass: 'col-12' },
      ]}
    />
  );
}

export default AdminHomeHighlights;
